import React, { FC, ReactNode } from 'react'
import { FlexColumn } from '@/atoms/FlexContainers'
import { Accordion, AccordionItem } from '@/molecules/Accordion'
import { useSafeRouter } from '@/utils/nextUtils/safe-router'
import { TranslateFunction, useTranslate } from '@/utils/translate/translate-client'
import {
  GParagraphMD,
  GParagraphSM,
  GResponsiveText,
  GTitleLG,
  GTitleSM,
  GTitleXL,
} from '@/views/PreSales/PreSalesGiveawayView/components/UI/Typography'
import { useGiveawayFaqs } from '@/views/PreSales/PreSalesGiveawayView/hooks/useGiveawayFaqs'

interface Props {
  theatricalSlug: string
}

export const PresalesFAQsTab: FC<Props> = ({ theatricalSlug }) => {
  const { t } = useTranslate('tickets')
  const { asPath } = useSafeRouter()
  const hash = (asPath as string).split('#')[1] || ''
  const faqs = useGiveawayFaqs(theatricalSlug)

  return (
    <FlexColumn className="mx-auto mb-16 gap-4 px-4 pt-16 md:px-16 md:pb-32 lg:px-24">
      <GResponsiveText
        color="giveaway-text-primary-dark"
        MobileTextComponent={GTitleLG}
        DesktopTextComponent={GTitleXL}
      >
        {t('GiveawayFaqs', 'Faqs')}
      </GResponsiveText>
      <Accordion>
        {faqs.map(
          (
            faq: {
              key: string
              question: (t: TranslateFunction) => string
              answer: (t: TranslateFunction) => ReactNode
            },
            index: number,
          ) => (
            <AccordionItem
              labelClassName="w-full  text-blue !font-semibold"
              showTopBorder
              label={<GTitleSM color="giveaway-text-primary-dark">{faq.question(t)}</GTitleSM>}
              key={index}
              borderColor="core-gray-300"
              defaultOpen={index === 0 || Boolean(hash && faq.key === hash)}
            >
              <GResponsiveText
                color="giveaway-text-subtle-light"
                MobileTextComponent={GParagraphSM}
                DesktopTextComponent={GParagraphMD}
              >
                {faq.answer(t)}
              </GResponsiveText>
            </AccordionItem>
          ),
        )}
      </Accordion>
    </FlexColumn>
  )
}
